import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { APPORVAL_REQUEST } from '../utils/constants';
import { makeGet } from '../utils/fetchUtils';

const ApprovalPage = () => {
    const [searchParams] = useSearchParams();
    const [statusMessage, setStatusMessage] = useState('Verifying...');
    const [hasVerified, setHasVerified] = useState(false); // New state to track verification
  
    useEffect(() => {
      
    //  console.log("searchParams ",searchParams);
    //  console.log("hasVar",hasVerified);
      
     document.title = 'Approval Page - Nclude Portal';
      verifyToken();
    }, []); 
  
    const verifyToken = async () => {
        if (hasVerified) return; // Exit if already verified
  
        const token = searchParams.get('token');
        // console.log("token ",token);
        if (!token) {
          setStatusMessage('No token provided.');
          return;
        }
        try {
          const response = await makeGet(`${APPORVAL_REQUEST}?token=${token}`);
          // console.log(response);
          setStatusMessage(response); // Adjust based on your actual API response
          setHasVerified(true); // Set the flag indicating verification is done
        } catch (error) {
          console.error('Error verifying token:', error);
          setStatusMessage('An error occurred during verification.');
          setHasVerified(true); // Ensure to set this even on error to prevent re-execution
        }
      };
  

    return (
      <div className='flex flex-col justify-center items-center'>
        <h2>Approval Status</h2>
        <p>{statusMessage}</p>
      </div>
    );
  };

export default ApprovalPage